<template>
  <b-modal
    centered
    @show="onShow"
    modal-class="c-wrap"
    dialog-class="c-dialog"
    header-class="popup_header1"
    content-class="c-content"
    body-class="c-body container"
    :visible="visible"
    hide-footer
    @hide="hide"
  >
    <template #modal-header="{ close }" style="padding-right: 5px;">
      <span style="margin: auto; margin-left: 180px;">&nbsp;&nbsp;&nbsp;충전하기</span>
      <h1 style="margin: 0; color: gray" @click="hide"><b-icon icon="x"></b-icon></h1>
    </template>
    <div style="display: flex; flex-direction: column; align-items: center">
      <span class="point_label">{{$t('more.charge_point1')}}</span>
      <span class="point_text">{{Utils.currency(charge_point)}}&nbsp;P</span>
      <b-container style="padding: 0;">
        <b-row>
          <b-col style="padding-right: 5px;">
            <b-button @click="chageCharge(5000,5000,5500, '5,500P')" variant="white" :class="['btn btn_text', add_point == 5000 ?'btn_active':'']">오천원</b-button>
          </b-col>
          <b-col style="padding-left: 5px;">
            <b-button @click="chageCharge(10000,10000,11000, '11,000P')" variant="white" :class="['btn btn_text', add_point == 10000 ?'btn_active':'']">만 원</b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col style="padding-right: 5px;">
            <b-button @click="chageCharge(20000,20000,22000, '22,000P')" variant="white" :class="['btn btn_text', add_point == 20000 ?'btn_active':'']">이만원</b-button>
          </b-col>
          <b-col style="padding-left: 5px;">
            <b-button @click="chageCharge(30000,30000,33000, '33,000P')" variant="white" :class="['btn btn_text', add_point == 30000 ?'btn_active':'']">삼만원</b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button @click="chageCharge(55000,55000,55000, '55,000P')" variant="white" :class="['btn btn_text', add_point == 55000 ?'btn_active':'']">
              <div>오만원</div>
              <span class="small_text">{{ u.format($t("more.bonus"), '10') }}</span>
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button @click="chageCharge(110000,110000,110000, '110,000P')" variant="white" :class="['btn btn_text', add_point == 110000 ?'btn_active':'']">
              <div>십만원</div>
              <span class="small_text">{{ u.format($t("more.bonus"), '10') }}</span>
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button @click="onAccount" variant="white" :class="['btn btn_text']">
              <div>계좌이체로 충전하기</div>
            </b-button>
          </b-col>
        </b-row>
      </b-container>

<!--      <div class="point_remain">
        {{u.format($t("more.point_remain"), Utils.currency(this.myinfo.point))}}
      </div>-->

      <!--
      <div style="margin-top: 5px; text-align:right; width: 100%;">
        <a class="go_account_text" @click="onAccount">{{$t('more.account_text')}}</a>
      </div>
      -->

      <div class="divider1" style="margin-top: 30px"/>
      <div class="footer">
        <div>
          <div class="total_pay" >{{$t("more.total_pay_amount")}}</div>
          <div class="charge_cost" >{{Utils.currency(this.charge_cost)}}{{$t("common.won")}}</div>
        </div>
        <b-button @click="onCharge(0)" class="charge_btn charge_btn_text" style="margin-left: 0;">
          카드결제
        </b-button>
      </div>
      <!--      <div class="footer">
              <b-button @click="onCharge(1)" class="charge_btn charge_btn_text">
                계좌이체
              </b-button>
              <b-button @click="onAccount" class="charge_btn charge_btn_text">
                &lt;!&ndash;{{$t("more.charging")}}&ndash;&gt;
                무통장입금
              </b-button>
            </div>-->
    </div>
    <CopyAccountPopup
      :visible.sync="showCopyAccountPopup"
    />
  </b-modal>
</template>

<script>
import moment from "moment";
import Utils from "../../../config/utils";
import CopyAccountPopup from "./CopyAccountPopup";
const u = require('util');

// const itemSkus = Platform.select({
//   ios: [
//     'item_1',
//     'item_2',
//     'item_3',
//     'item_4',
//     'item_5',
//     'item_6',
//   ],
//   android: [
//     'item_1',
//     'item_2',
//     'item_3',
//     'item_4',
//     'item_5',
//     'item_6',
//   ],
// });

export default {
  name: "ChargePointPopup",
  components:{
    CopyAccountPopup
  },
  props:{
    visible:{
      type:Boolean,
      default:false,
    },
  },
  data() {
    return {
      showCopyAccountPopup:false,
      charge_point:0,
      add_point: 0,
      charge_cost: 0,
      product_name: '',
      Utils:Utils,
      u:u,
      productList:[],
    }
  },
  methods:{

    onCharge(pay_gb) {
      let {charge_cost} = this;
      let sku = "";

      if (charge_cost == 0) {
        Utils.toast(this, this.$t('more.no_point_payment'));
        return;
      }

      // if (charge_point == 5000) {
      //   sku = itemSkus[0];
      // } else if (charge_point == 10000) {
      //   sku = itemSkus[1];
      // } else if (charge_point == 20000) {
      //   sku = itemSkus[2];
      // } else if (charge_point == 30000) {
      //   sku = itemSkus[3];
      // } else if (charge_point == 55000) {
      //   sku = itemSkus[4];
      // } else if (charge_point == 99000) {
      //   sku = itemSkus[5];
      // }

      // this.requestPurchase(sku);
      // this.onChargeSuccess();

      if(pay_gb == 0){
        this.requestAimportPurchase(charge_cost, 'card');
      } else if(pay_gb == 1){
        this.requestAimportPurchase(charge_cost, 'trans');
      } else if(pay_gb == 2){
        this.requestAimportPurchase(charge_cost, 'vbank');
      }

    },

    onAccount() {
      this.showCopyAccountPopup = true;
    },

    onChargeSuccess() {
      let { charge_point } = this;
      console.log("-----Charge Point :", charge_point);

      this.myinfo.point += charge_point;
      this.charge_point = this.myinfo.point;
      this.myinfo.saveInfo();

      /*Utils.requestPost(
        this.$c.API.Purchase.buyPoint,
        {
          point: charge_point
        },
      ).then(result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.myinfo.point += charge_point;
          this.charge_point = this.myinfo.point;
          this.myinfo.saveInfo();
          // if (this.onCharge) {
          //   this.onCharge();
          // }
        } else {
          Utils.toast(this, result.msg);
        }
      });*/
    },

    async requestAimportPurchase(point, payment) {
      var self = this;
      IMP.request_pay(
        {
          pg: "uplus.im_madepf29lg",
          pay_method: payment,
          merchant_uid: "merchant_" + this.myinfo.uid + "_" + new Date().getTime(),
          name: this.product_name,
          amount: point,
          buyer_tel: this.myinfo.phone,
        },
        function (rsp) {
          if (rsp.success) {
            //4. 결제 요청 결과 서버(자사)에 적용하기
            //ajax 서버 통신 구현 -> 5. 서버사이드에서 validation check

            //6. 최종 서버 응답 클라이언트에서 단계 4.에서 보낸 서버사이드 응답 에따라 결제 성공 실패 출력
            // var msg = "결제가 완료되었습니다.";
            // msg += "고유ID : " + rsp.imp_uid;
            // msg += "상점 거래ID : " + rsp.merchant_uid;
            // msg += "결제 금액 : " + rsp.paid_amount;
            // msg += "카드 승인번호 : " + rsp.apply_num;

            self.onChargeSuccess();
            Utils.toast(self, "충전되었습니다. 새로고침 해주세요.");
          } else {
            var msg = "결제에 실패하였습니다.";
            msg += "에러내용 : " + rsp.error_msg;
            alert(msg);
          }
        }
      );
    },

    async requestPurchase(sku) {
      this.getItems();
      try {
        RNIap.requestPurchase(sku);
      } catch (err) {
        console.warn(err.code, err.message);
      }
    },

    async getItems() {
      try {
        const products = RNIap.getProducts(itemSkus);
        // const products = RNIap.getSubscriptions(itemSkus);
        this.productList = products;
      } catch (err) {
        // console.warn(err.code, err.message);
      }
    },

    chageCharge(add_point, charge_point, charge_cost, product_name) {
      this.add_point = add_point;
      this.charge_point = charge_point;
      this.charge_cost = charge_cost;
      this.product_name = product_name;
    },
    hide(){
      if(window.history.state == "forward")
        window.history.back();
    },
    onShow(){
      this.eventBus.$emit('setModal', this);
      window.history.pushState('forward', null, );
    },

  },
  inject: ['eventBus'],
  mounted() {
    var IMP = window.IMP;
    IMP.init("imp59828114");

    this.myinfo.loadInfo();
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/css/vars";
.point_label{
  color: $c_457fff;
  font-size: $fs_16;
  font-family: $korean_gd_14_r;
  margin-top: 20px;
};
.point_text{
  color: $black;
  font-size: $fs_30;
  font-family: $korean_gd_17_r;
  margin-bottom: 30px;
  margin-left: 10px;
  margin-top: 10px;
};

.btn{
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  width: 90%;
  border-style: solid;
  border-width: 1.5px;
  border-color: #e5e4e1;
  border-radius: 5px;
  margin-bottom: 7px;
};
.btn_active{
  border-color: $c_457fff;
  color: $c_457fff!important;
};
.btn_text{
  font-size: $fs_22;
  color: #e5e4e1;
  font-family: $korean_gd_17_r;
  width: 100%;
};
.small_text{color: white; background-color: #e5e4e1; font-size: $fs_12; font-family: $korean_gd_19_r; border-radius: 5px; margin-left: 8px; padding: 2px 4px;};
.btn_active .small_text {background-color: #cf0000}

.divider{background-color: #f9f9f9; height: 10px; margin-top: 25px; margin-bottom: 20px;};
.caption{color: $black; font-size: $fs_15};
.point_remain{
  width: 100%;
  text-align: right;
  font-size: $fs_22;
  font-family: $korean_gd_17_r;
  color: #7b7b7b;
  //alignSelf: 'flex-end'
  margin-right: 50px;
  margin-top: 30px;
};
.divider1{width:99vw;height: 5px; background-color: #f7f7f7; margin:15px 0 0 0};
.footer{
  display:flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 99px;
  margin-bottom: -1rem;
  padding: 5px 20px 0px 20px;
};
.charge_btn{
  max-width: 150px;
  height: 50px;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  background-color: $c_457fff;
  margin-left: 20px;
  bottom: 6px;
  margin-top: 11px;
};
.charge_btn_text{color: $white; font-size: $fs_20; font-family: $korean_gd_15_r};
.total_pay{color: $c_457fff; font-size: $fs_14; font-family: $korean_gd_14_r};
.charge_cost{
  color: $black;
  font-size: 28px;
  font-family: $korean_gd_17_r;
  //margin-top: 11px;
};
.go_account_text{
  color: #cf0000;
  font-size: 22px;
  font-family: $korean_gd_15_r;
  text-align: right;
  margin-right: 25px;
  cursor: pointer;
  text-decoration: underline;
};

</style>



// WEBPACK FOOTER //
// src/components/controls/popup/ChargePointPopup.vue